import * as managementGiftForm from '../services/managementGiftForm';
import { fmtThousand } from '@/utils/comUtil';
import dayjs from 'dayjs';

export default {
  namespace: 'managementGiftFormMolding',
  state: {},
  effects: {
    *editManagementGiftForm({ payload: { values }, callback }, { call }) {
      console.log('values', values);
      const cost = values.cost ? values.cost.replace(/,/g, '') : values.cost;
      const minPointInit = values.minPoint
        ? values.minPoint.replace(/,/g, '')
        : values.minPoint;
      const giftMonthlyExchangeNumInit = values.giftMonthlyExchangeNum
        ? values.giftMonthlyExchangeNum.replace(/,/g, '')
        : values.giftMonthlyExchangeNum;
      const stock = values.stock
        ? values.stock.replace(/,/g, '')
        : values.stock;
      const coupon =
        (values.receiveMethod === 'TAKE_THEIR' &&
          values.type === 'REAL_PRIZE') ||
        values.type === 'COUPON'
          ? {
              beginTime: values.couponInfo.beginTime,
              couponId: values.couponInfo.couponId,
              couponName: values.couponInfo.couponName,
              couponType: 4,
              endTime: values.couponInfo.endTime,
            }
          : null;
      const isNewMember = values.rule?.includes('1') ? 1 : 0;
      const isOldMember = values.rule?.includes('2') ? 1 : 0;
      const minPoint = values.rule?.includes('3') ? minPointInit : null;
      const giftMonthlyExchangeNum = values.rule?.includes('5')
        ? giftMonthlyExchangeNumInit
        : null;
      const receiveMethod =
        values.type === 'REAL_PRIZE' ? values.receiveMethod : null;
      const levels =
        values.rule?.includes('4') && values.levels ? values.levels : null;
      const params = {
        beginDateTime: values.date
          ? `${dayjs(values.date.startDate).format('YYYY-MM-DD')} 00:00:00`
          : null,
        cost,
        coupon,
        coverImage: values.coverImage[0],
        description: values.description,
        endDateTime: values.date
          ? `${dayjs(values.date.endDate).format('YYYY-MM-DD')} 23:59:59`
          : null,
        images: values.images,
        isNewMember,
        isOldMember,
        levels,
        minPoint,
        giftMonthlyExchangeNum,
        receiveMethod,
        stock,
        title: values.title,
        type: values.type,
        id: values.id,
        pointsType: 'UGC_SHELF',
      };
      const res = values.id
        ? yield call(managementGiftForm.updateGift, params, callback)
        : yield call(
            managementGiftForm.editManagementGiftForm,
            params,
            callback,
          );
      callback(res);
    },
    *getQueryGiftDetail({ payload: { values } }, { call, put }) {
      const res = yield call(managementGiftForm.getQueryGiftDetail, values);
      const cost = fmtThousand(res.data.cost);
      const minPoint = res.data.minPoint ? fmtThousand(res.data.minPoint) : 0;
      const giftMonthlyExchangeNum = res.data.giftMonthlyExchangeNum
        ? fmtThousand(res.data.giftMonthlyExchangeNum)
        : 0;
      const stock = fmtThousand(res.data.stock);
      const rule = [];
      console.log('000');
      if (res.data.isNewMember) {
        rule.push('1');
      }
      if (res.data.isOldMember) {
        rule.push('2');
      }
      if (res.data.minPoint) {
        rule.push('3');
      }
      if (res.data.giftMonthlyExchangeNum) {
        rule.push('5');
      }
      if (res.data.levels && res.data.levels?.length > 0) {
        rule.push('4');
      }
      const levels = res.data.levels
        ? res.data.levels.map((item) => String(item))
        : null;
      const params = {
        title: res.data.title,
        cost,
        couponInfo: res.data.coupon,
        coverImage: [res.data.coverImage],
        description: res.data.description,
        date: {
          startDate: res.data.beginDateTime,
          endDate: res.data.endDateTime,
        },
        images: res.data.images,
        rule,
        levels,
        minPoint,
        giftMonthlyExchangeNum,
        receiveMethod: res.data.receiveMethod,
        stock,
        type: res.data.type,
        code: res.data.code,
      };
      yield put({
        type: 'save',
        payload: {
          detailInfo: params,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname.includes('management_gift_form_edit') ||
          props.pathname.includes('management_gift_form_add') ||
          props.pathname.includes('management_gift_form_detail')
        ) {
          dispatch({
            type: 'save',
            payload: {
              detailInfo: null,
            },
          });
        }
      });
    },
  },
};
